const TipoAbitazioneEnum = {
  PROPRIETA: 2,
  LOCAZIONE: 1,
  NO_ABITAZIONE: 3,
  USUFRUTTO: 4,
  DORMITORIO: 5,
  COMODATO: 6,
  ALTRO: 7,
};

TipoAbitazioneEnum.getLabel = function (value) {
  switch (value) {
    case this.PROPRIETA:
      return "Proprietà";
    case this.LOCAZIONE:
      return "Locazione";
    case this.NO_ABITAZIONE:
      return "Nessuna abitazione";
    case this.USUFRUTTO:
      return "Usufrutto";
    case this.DORMITORIO:
      return "Dormitorio";
    case this.COMODATO:
      return "Comodato d'uso";
    case this.ALTRO:
      return "Altro";
    default:
      return value;
  }
};

export default TipoAbitazioneEnum;
